export const MIN_VALUE = 'minValue'
export const MAX_VALUE = 'maxValue'
export const MIN_CRITICAL_VALUE = 'minCriticalValue'
export const MAX_CRITICAL_VALUE = 'maxCriticalValue'